import * as React from 'react';
import styled from 'styled-components';
import { colors } from 'kaizen-ui-colors/lib';
import Project from '../../../domain/entity/Project';
import Variation from '../../../domain/entity/Variation';
import config from '../../../config';

interface IProps {
  project: Project;
  variation: Variation;
}

const Wrapper = styled.div`
  display: flex;
  margin: 0 0 10px;
  padding: 0 0 10px;
  border-bottom: 1px solid ${colors.mochi_dark__ebedef};

  &:last-child {
    border-bottom: 0;
  }

  @media (min-width: 768px) {
    flex-direction: column;
    margin: 0 10px;
    padding: 0 10px;
    border-bottom: 0;
  }
`;

const VariationImageWrapper = styled.div`
  width: 120px;
  height: 90px;
  overflow: hidden;
  margin-right: 20px;
  object-fit: scale-down;
  background-color: ${colors.lithium__dbe0eb};

  img {
    width: 100%;
  }

  @media (min-width: 768px) {
    margin-right: 0;
    margin-bottom: 12px;
  }
`;

const VariationMobileImageWrapper = VariationImageWrapper.extend`
  height: 180px;
`;

const VariationId = styled.div`
  height: 18px;
  line-height: 18px;
  font-size: 11px;
  color: ${colors.ash__b4bed5};
  margin-bottom: 4px;
`;

const ImprovementRate = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
`;

const ImprovementRateLabel = styled.span`
  font-size: 11px;
  margin-right: 8px;
  white-space: nowrap;
`;

const ImprovementRateValue = styled.div`
  font-size: 18px;
  font-weight: 700;
  font-family: Verdana, sans-serif;

  @media (min-width: 768px) {
    font-size: 20px;
  }
`;

const ImprovementRateActiveValue = ImprovementRateValue.extend`
  color: ${colors.veggie__2dcc70};
`;

const ImprovementRateNegativeValue = ImprovementRateValue.extend`
  color: ${colors.lava__fe7877};
`;

const VariationPaused = styled.span`
  display: inline-block;
  font-size: 11px;
  font-weight: bold;
  color: ${colors.lava__fe7877};
  margin-left: 4px;
`;

const Metric = styled.div`
  color: ${colors.ash_dark__878fa0};
  font-size: 12px;
  font-family: Verdana, sans-serif;
`;

const VariationUser = styled.div`
  margin-top: 8px;

  a,
  span {
    display: inline-block;
  }
`;

export class RoundMonitorVariationListItem extends React.Component<IProps, {}> {
  public render() {
    const { project, variation } = this.props;
    const variationUrl = `${config.dashboard}/experiments/${project.id}/variations/${variation.id}`;
    const cvr = variation.pv === 0 ? 0 : Math.floor(variation.cv * 1000 / variation.pv) / 10;
    return (
      <Wrapper>
        {project.isMobileWeb ? (
          <VariationMobileImageWrapper>
            <a href={variationUrl} target="_blank" rel="noreferrer noopener">
              <img src={variation.screenshotImage} />
            </a>
          </VariationMobileImageWrapper>
        ) : (
          <VariationImageWrapper>
            <a href={variationUrl} target="_blank" rel="noreferrer noopener">
              <img src={variation.screenshotImage} />
            </a>
          </VariationImageWrapper>
        )}
        <div>
          <VariationId>
            #{variation.id}
            {variation.paused ? <VariationPaused>(一時停止中)</VariationPaused> : ''}
          </VariationId>
          <ImprovementRate>
            <ImprovementRateLabel>改善率</ImprovementRateLabel>
            {variation.formattedScore > 100 ? (
              <ImprovementRateActiveValue>{variation.formattedScore}%</ImprovementRateActiveValue>
            ) : variation.formattedScore < 100 ? (
              <ImprovementRateNegativeValue>{variation.formattedScore}%</ImprovementRateNegativeValue>
            ) : (
              <ImprovementRateValue>{variation.formattedScore}%</ImprovementRateValue>
            )}
          </ImprovementRate>
          <Metric>CVR: {cvr}%</Metric>
          <Metric>CV数: {variation.cv.toLocaleString()}</Metric>
          <Metric>訪問数: {variation.pv.toLocaleString()}</Metric>
          <VariationUser>
            {variation.user ? (
              <a
                href={`${config.dashboard}/users/${variation.user.id}`}
                target="_blank"
                rel="noreferrer noopener"
                title={variation.user.username}
              >
                {variation.user.username}
              </a>
            ) : (
              <span>(Deleted user)</span>
            )}
          </VariationUser>
        </div>
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/presentation/component/RoundMonitor/RoundMonitorVariationListItem.tsx